import { cn } from "@productlane/lib/src/browser"
import { Tooltip } from "@productlane/ui"

/** 8px dot plus a 6px gap: pair it with useReadTransition(…, "-translate-x-3.5"). */
export function UnreadDot({
	show,
	className,
}: {
	show: boolean
	className?: string
}) {
	if (!show) return null

	// The tooltip stays on through the exit; swapping the wrapper would remount the dot mid-fade.
	return (
		<Tooltip label="Unread thread" shouldWrapChildren>
			<span
				data-unread-dot
				className={cn(
					"mr-1.5 h-2 w-2 flex-none rounded-full bg-blue-500 dark:bg-blue-400",
					className,
				)}
			/>
		</Tooltip>
	)
}
